<main>
  <offering>
    <name><h2>iOS apps</h2></name>
    <rate><h5>$275/hr</h5></rate>
    <description>Existing apps & green-builds. Swift, ObjC, UIKit, SwiftUI; all aspects of development & design</description>
  </offering>

  <offering>
    <name><h2>websites</h2></name>
    <rate><h5>$175/hr</h5></rate>
    <description>Green-builds, static sites or dynamic front-ends for existing back-ends</description>
  </offering>

  <divider/>

  <offering>
    <name><h2>backend & cloud</h2></name>
    <rate><h5>$215/hr</h5></rate>
    <description>Scalable, secure, high performance backends. Custom built with the latest AWS tooling, exposed through modern API surfaces. </description>
  </offering>

  <divider/>

  <offering>
    <name><h2>dev practice modernization</h2></name>
    <rate><h5>$305/hr</h5></rate>
    <description>Go from idea to live in production 1-3 orders of magnitude faster.
      Technology, Process & Politics overhauls or third-party evaluation.</description>
  </offering>

  <offering>
    <name><h2>startup in a box</h2></name>
    <rate><h5>$405/hr</h5></rate>
    <description>Like hiring a technical co-founder. Complete technology stack, custom built. No equity required.</description>
  </offering>

  <divider/>


  <sectionBreak>
    <h1>Industry Experience</h1>
    <h5>2008 -- 2020</h5>
  </sectionBreak>

  <industryExperience>
    <logo><img src="/images/schwab-logo.png"/></logo>
    <companyName><h2>Charles Schwab</h2><h5>Sr. Staff Engineer</h5></companyName>
  </industryExperience>

  <industryExperience>
    <logo><img src="/images/truecar_logo.jpg"/></logo>
    <companyName><h2>TrueCar</h2><h5>Sr. Engineer</h5></companyName>
  </industryExperience>

  <industryExperience>
    <logo><img src="/images/aetna-logo.png"/></logo>
    <companyName><h2>Aetna</h2><h5>Sr. Engineer</h5></companyName>
  </industryExperience>

  <industryExperience>
    <logo><img src="/images/davita-logo.png"/></logo>
    <companyName><h2>DaVita</h2><h5>Engineer</h5></companyName>
  </industryExperience>

  <industryExperience>
    <logo><img src="/images/carlyle-logo.png"/></logo>
    <companyName><h2>The Carlyle Group</h2><h5>Sr. Analyst</h5></companyName>
  </industryExperience>

  <sectionBreak>
    <h1>B.A. Mathematics</h1>
    <h4>2002</h4>
    <h5>University of Colorado, Boulder</h5>
  </sectionBreak>
</main>

<style>
  main {
    width: 100%;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 1rem; padding-right: 1rem;
    overflow-x: hidden;

    overflow-y: scroll;
    scrollbar-width:none;
  }
  main::-webkit-scrollbar {
    display: none;
  }

  offering {
    display: grid;
    grid-template-columns: auto 150px;
    grid-template-rows: auto auto;
    grid-template-areas:
    "name rate"
    "description description"
  ;
    justify-items: stretch;
    align-items: stretch;

    margin-bottom: 25px;
    max-width: 98%;
  }

  name {
    grid-area: name;
    display: flex;
    flex-direction: row;
    align-items: center;

    color: #202043;
    text-align: left;
  }

  rate {
    grid-area: rate;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    margin-right: 12px;

    color: #0a0724
  }

  description {
    grid-area: description;
    max-width: 300px;
    text-align: left;
  }

  industryExperience {
    display: grid;
    grid-template-columns: 120px auto;
    grid-template-rows: 80px;
    grid-template-areas:
    "logo companyName"
  ;
    justify-items: stretch;
    align-items: stretch;

    margin-bottom: 45px;
  }

  logo {
    grid-area: logo;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  logo img {
    max-width: 110px;
    height: auto;
  }

  companyName {
    grid-area: companyName;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    margin-left: 15px;
  }

  companyName h2 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  companyName h5 {
  margin-left: 30px;
  margin-top: 0px;
  }

  h2, h5 {
    margin-bottom: 12px;
  }

  sectionBreak h1 {
    margin-top: 120px;
    margin-bottom: 10px;
  }
  sectionBreak h4, h5 {
    margin-top: 10px;
  }

  sectionBreak h5 {
    margin-bottom: 50px;
  }

  @media only screen and (max-width: 600px) {
    h2 {
      font-size: 1.6rem ;
    }
    h5 {
      font-size: 1.2rem;
    }
    main {
      overflow-x: hidden;
    }
  }
</style>
